import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BulkRecreateOrdersService } from '../../services/bulk-recreate-orders.service';
import { read, utils, WorkBook } from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bulk-recreate-upload',
  templateUrl: './bulk-recreate-upload.component.html',
  styleUrls: ['./bulk-recreate-upload.component.scss']
})
export class BulkRecreateUploadComponent implements OnInit, AfterViewInit {

  isFileUploaded: boolean = false;
  isProcessing: boolean = false;
  tableColumns: string[] = ['reference', 'status', 'messages', 'actions'];
  dataSource  = new MatTableDataSource<BulkRecreateUploadTable>([]);
  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(private bulkRecreateOrdersService: BulkRecreateOrdersService, public dialogRef: MatDialogRef<BulkRecreateUploadComponent>) {
  }

  ngOnInit(): void {
    this.bulkRecreateOrdersService.recreateOrdersResponse$.pipe(/** add on destroy */).subscribe((response) => {
      this.isProcessing = false;
      const tableData = response.map(item => ({
        reference: item.customer_reference,
        status: item.is_success === true ? 'Recreated' : 'Failed',
        messages: item.error_message || 'N/A',
        orderId: item.new_order_id
      }));
      this.dataSource.data = tableData;
      this.dataSource.paginator = this.paginator;
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  uploadFile($event: FileList): void {
    // Logic to open file upload dialog
    this.isProcessing = true;
    this.isFileUploaded = true;
    this.dialogRef.disableClose = true;

    if($event.item(0)){
      const files: File = $event.item(0);
      const reader: FileReader = new FileReader();

      reader.onload = (file: ProgressEvent<FileReader>) => {
        /* read workbook */
        const ab: ArrayBuffer | string = file.target.result;
        const wb: WorkBook = read(ab);

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        /* save data */
        const data = (utils.sheet_to_json(ws, {header: 1}));
        const refs = data.map((y: string[]) => y[0]);

        this.bulkRecreateOrdersService.processUploads(refs);
      }
      reader.readAsArrayBuffer(files);
    }
  }

  openInNewTab(orderId: string): void {
    if(orderId){
      window.open(window.location.origin + '/dashboard/orders/trip/' + orderId);
    }
  }

  setDataSourceAttributes(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  skipProcessing(): void{
    this.isFileUploaded = true;
    this.isProcessing = false;
  }
}

export interface BulkRecreateUploadTable {
  reference: string;
  status: string;
  messages: string;
  orderId: string | null;
}

